<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M17 13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1 0-1h9a.5.5 0 0 1 .5.5ZM13.5 17h-6a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1ZM22 9.985V19.5c0 2.481-2.019 4.5-4.5 4.5h-11A4.505 4.505 0 0 1 2 19.5v-15C2 2.019 4.019 0 6.5 0h5.515c1.735 0 3.368.676 4.597 1.904l3.484 3.485A6.453 6.453 0 0 1 22 9.985ZM15.904 2.61A5.473 5.473 0 0 0 14 1.379v5.12c0 .827.673 1.5 1.5 1.5h5.121a5.48 5.48 0 0 0-1.232-1.904L15.905 2.61ZM21 9.985c0-.335-.038-.663-.096-.985H15.5A2.503 2.503 0 0 1 13 6.5V1.096A5.564 5.564 0 0 0 12.015 1H6.5C4.57 1 3 2.57 3 4.5v15C3 21.43 4.57 23 6.5 23h11c1.93 0 3.5-1.57 3.5-3.5V9.985Z"
                fill="currentColor"
                opacity="1"
                data-original="currentColor"
                class=""></path>
        </g>
    </svg>
</template>
